// extracted by mini-css-extract-plugin
export default {"root":"messages_root__MJPjJ","closeAll":"messages_closeAll__39-vL","messageCount":"messages_messageCount__DVJAS","message":"messages_message__d3zWm"};